/**
 * @deprecated This enum is deprecated and should not be used in new code.
 * Use ModuleCategoryEnum from application-types instead.
 */
export enum ModuleCategoryEnum {
  WorkOrders = 'WorkOrders',
  BillingPayments = 'BillingPayments',
  VisitorManagement = 'VisitorManagement',
  AccessManagement = 'AccessManagement',
  Inspections = 'Inspections',
}
